const LINKS = [
  'sports.williamhill',
  //   'sports.williamhill-pp1.es',
  //   'sports.williamhill.es',
  'custhelp.com',
  // 'williamhill-es--tst.custhelp.com'
  // 'williamhill-es.custhelp.com'
];

export const setESWrapperLinksToOpenInExternal = async () => {
  window.webkit?.messageHandlers?.cbCallBackHandlerCGP?.postMessage(
    JSON.stringify({
      Func: 'LinksToOpenInExternal',
      links: LINKS,
    })
  );
};
